import { render, staticRenderFns } from "./ProductInquiryNew.vue?vue&type=template&id=1171252c&scoped=true"
import script from "./ProductInquiryNew.vue?vue&type=script&lang=js"
export * from "./ProductInquiryNew.vue?vue&type=script&lang=js"
import style0 from "./ProductInquiryNew.vue?vue&type=style&index=0&id=1171252c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171252c",
  null
  
)

export default component.exports